import { PlannerWithDetails } from '@/common/types/databaseTypes';
import { isSameDate } from '@tickitacka/shared';
import { create } from 'zustand';

// planner 페이지에서 다루는 상태들 관리
// 1. 선택된 날짜
// 2. 선택된 날짜에 해당하는 플래너 리스트?

interface PlannerStore {
    selectedDate: Date; // planner(리스트, 캘린더) 날짜
    calendarDate: Date; // 캘린더 날짜 - selectedDate와 일방향적으로 동기화 (sel -o-> cal, cal -x-> sel)
    dateActions: {
        // 날짜 변경 관련
        setSelectedDate: (date: Date) => void;
        setCalendarDate: (date: Date) => void;
        goToday: () => void;
        incrementSelectedDate: () => void;
        decrementSelectedDate: () => void;

        // 플래너 관련
    };
    plannerActions: {
        getFilteredPlanners: (
            planners: PlannerWithDetails[]
        ) => PlannerWithDetails[];
    };
}

export const usePlannerStore = create<PlannerStore>((set, get) => ({
    selectedDate: new Date(),
    calendarDate: new Date(),
    dateActions: {
        setSelectedDate: (date: Date) => set({ selectedDate: date }),
        setCalendarDate: (date: Date) => set({ calendarDate: date }),
        goToday: () => set({ selectedDate: new Date() }),
        incrementSelectedDate: () =>
            set(state => {
                const newDate = new Date(state.selectedDate);
                newDate.setDate(newDate.getDate() + 1);
                return { selectedDate: newDate };
            }),
        decrementSelectedDate: () =>
            set(state => {
                const newDate = new Date(state.selectedDate);
                newDate.setDate(newDate.getDate() - 1);
                return { selectedDate: newDate };
            }),
    },
    plannerActions: {
        getFilteredPlanners: (planners: PlannerWithDetails[]) => {
            const { selectedDate } = get();

            return (
                planners?.filter(planner =>
                    isSameDate(planner.planner_date, selectedDate.toISOString())
                ) ?? []
            ).sort(
                (a, b) =>
                    new Date(b.register_date).getTime() -
                    new Date(a.register_date).getTime()
            );
        },
    },
}));
